<ng-container *transloco="let t">
    <div class="px-8 sm:px-32 bg-gray-100 pt-24 pb-28">
        <!--Heading-->
        <h1 class="text-2xl sm:text-2xl md:text-4xl lg:text-4xl font-bold text-black text-center mb-20"
            [innerHTML]="i18nHeading | transloco"></h1>
        <!--Slides-->
        <owl-carousel-o [options]="customOptions">
            <ng-container *ngFor="let item of items">
                <ng-template carouselSlide [id]="item.i18nKey">
                    <div class="flex flex-col items-center">
                        <img [src]="item.image" style="width: 96px; height: 96px">
                        <p class="text-black text-center text-lg mt-4">{{t(item.i18nKey)}}</p>
                    </div>
                </ng-template>
            </ng-container>
        </owl-carousel-o>
    </div>
</ng-container>
